/** @format */
import isPropValid from '@emotion/is-prop-valid';
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, ReactNode, useContext } from 'react';
import styled from 'styled-components';

import { ApplicationContext } from '@toucan/client/global/application';

import { styles } from './question-modal-content.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface QuestionModalContentProps {
    /**
     * The content to sit underneath the title
     */
    children?: ReactNode;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledQuestionModalContent = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const QuestionModalContent: FunctionComponent<
    QuestionModalContentProps
> = ({ children, ...otherProps }: QuestionModalContentProps) => {
    const { t } = useTranslation();
    const { setModalVisible } = useContext(ApplicationContext);

    return (
        <StyledQuestionModalContent {...otherProps}>
            {children}
            <div className="modal-button-container">
                <Button
                    variant={ButtonVariant.SECONDARY}
                    className="modal-button"
                    onClick={() => setModalVisible(false)}
                >
                    {t('Ok')}
                </Button>
            </div>
        </StyledQuestionModalContent>
    );
};
